'use client';

import type { FC } from 'react';
import Link from 'next/link';
import { DesktopDropsFeed } from './desktop/DesktopDropsFeed';
import { useOnlineCount } from '../queries/useOnlineCount';
import { useOnlineCountSubscription } from '../hooks/useOnlineCountSubscription';
import { useIsDesktop } from '../hooks/useIsDesktop';
import { useLocalTranslation } from '../hooks/useLocalTranslation';
import { useLocalizedHref } from '../hooks/useLocalizedHref';
import desktopHeaderTranslations from './desktop/DesktopHeader.translations';

export const MobileGuestChrome: FC = () => {
  const isDesktop = useIsDesktop();
  const { data: onlineCountApi } = useOnlineCount();
  const onlineCountWs = useOnlineCountSubscription();
  const onlineCount = onlineCountWs ?? onlineCountApi;
  const { t } = useLocalTranslation(desktopHeaderTranslations);
  const localize = useLocalizedHref();

  if (isDesktop) return null;

  return (
    <div className="-mx-4 -mt-4 mb-2 flex flex-col">
      <header className="flex items-center justify-between px-4 py-3 border-b border-white/[0.06]">
        <div className="flex items-center gap-3">
          <span
            className="font-sans text-2xl tracking-widest uppercase select-none"
            style={{
              fontWeight: 800,
              letterSpacing: '0.18em',
              background: 'linear-gradient(to top, #7C3AED 0%, #A78BFA 50%, #00C8FF 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              filter: 'drop-shadow(0 0 6px rgba(167,139,250,0.5)) drop-shadow(0 0 10px rgba(0,200,255,0.3))',
            }}
          >
            SHOT
          </span>
          {onlineCount != null && onlineCount > 0 && (
            <div className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-green animate-pulse" />
              <span className="text-xs font-bold text-white/50 tabular-nums">{onlineCount}</span>
            </div>
          )}
        </div>
        <Link
          href={localize('/login')}
          className="px-3 py-1.5 rounded-xl bg-accent-green text-white font-semibold text-xs hover:opacity-90 transition-opacity"
        >
          {t('login')}
        </Link>
      </header>
      <DesktopDropsFeed />
    </div>
  );
};
